import { render, staticRenderFns } from "./FinishAddVault.vue?vue&type=template&id=61c174be"
import script from "./FinishAddVault.vue?vue&type=script&lang=js"
export * from "./FinishAddVault.vue?vue&type=script&lang=js"
import style0 from "./FinishAddVault.vue?vue&type=style&index=0&id=61c174be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports